/***  stylesHookUps.js ***/
/* Project: Pump Panel Simulator
   Descript: Training tool to assist in learing 
   Created: Kendra Wainscott  2022

   Styles for HookUps component 
   Organized alphabetically
*/
import {masterStyles} from "../../masterStyles";
const c = masterStyles.colorPalette;

const capImg = {
  width: "15em",
};

export const hookUpsStyles = {
  capImg: capImg,
};
